import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex"
  },
  paper: {
    marginTop: 15,
    marginBottom: 15,
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column"
  },
  formHeight: {
    height: 300
  },
  formControl: {
    margin: theme.spacing(3)
  },
  opcionCarrier: {
    height: 115
  }
}));
